/**
 * It takes the username and password from the .env file and uses them to authenticate with the API.
 * @returns The JWT token.
 */
import axios from "axios";

export let signIn = async () => {
  var session_url = process.env.REACT_APP_LBDA + "auth";
  var username = process.env.REACT_APP_AUTH_USER_LBDA;
  var password = process.env.REACT_APP_AUTH_USERPASS_LBDA;
  try {
    const response = await axios.get(session_url, {
      auth: {
        username: username,
        password: password,
      },
    });
    return response.data.jwt;
  } catch (error) {
    return error;
  }
};
